import Lottie from 'lottie-light-react'
import animationData from '../../assets/loading.json'
import {general as textsGeneral} from '../../translate/Translate.jsx'

import './loadingPage.scss'

const LoadingPage = () => {
    return <div className={'loading-page'}>
        <Lottie
            animationData={animationData}
            className={'lottie-loading'}/>
        <label className={'label'}>{textsGeneral.loading}</label>
    </div>
}

export default LoadingPage
